import { render, staticRenderFns } from "./VideoForm.vue?vue&type=template&id=4e77eb03&scoped=true&"
import script from "./VideoForm.vue?vue&type=script&lang=ts&"
export * from "./VideoForm.vue?vue&type=script&lang=ts&"
import style0 from "./VideoForm.vue?vue&type=style&index=0&id=4e77eb03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e77eb03",
  null
  
)

export default component.exports